import React, { useState } from 'react';
import KenBurnsImage from './KenBurnsImage';
import getImageUrl from '../functions/getImageUrl';
import BackgroundElementPoster from './BackgroundElementPoster';
import BackgroundElementBackground from './BackgroundElementBackground';

const BackgroundVisuals = ({ isInHighlight, oddSlide, isMobile, kenBurnsToggle, canParallax, isJustOneItem, backgroundVisualsSettings, autoplaySpeed, backgroundImage, poster }) => {
    const [fallbackInUse, setFallback] = useState(false)
    const { style } = backgroundVisualsSettings;
    const cssClassesBackground = "image background-visuals-container";
    let cssClassesPoster = 'background-visuals-poster theme-radius-posters-full';
    if (style.includes('PosterRight')) cssClassesPoster += ' background-visuals-poster-right';
    
    const {finalImageURl, imageUrl, position} = getImageUrl(backgroundImage, isMobile, false, true)
    const posterSettings = poster ? getImageUrl(poster, isMobile, true, false) : null

    let styles = {    
        objectPosition: position
    }

    let ambientStyle = {
        backgroundImage: `url(${finalImageURl})` 
    }
    
    switch (style) {
        case 'Classic': return (
            canParallax ? (
                <div className={cssClassesBackground} style={ambientStyle}></div>
            ) : (
                <div className={cssClassesBackground}>
                    <BackgroundElementBackground
                        src={finalImageURl}
                        srcFallback={imageUrl}
                        imgStyles={styles}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />
                </div>
            )
        );
        case 'ClassicPosterCenter': return (
            canParallax ? (
                <div className={cssClassesBackground} style={ambientStyle}></div>
            ) : (
                <div className={cssClassesBackground}>                    
                    <BackgroundElementBackground
                        src={finalImageURl}
                        srcFallback={imageUrl}
                        imgStyles={styles}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />

                    <BackgroundElementPoster
                        poster={poster}
                        cssClassesPoster={cssClassesPoster}
                        posterSettings={posterSettings}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />
                </div>
            )
        );
        case 'ClassicPosterRight': return (
            canParallax ? (
                <div className={cssClassesBackground} style={ambientStyle}></div>
            ) : (
                <div className={cssClassesBackground}>
                    <BackgroundElementBackground
                        src={finalImageURl}
                        srcFallback={imageUrl}
                        imgStyles={styles}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />

                    <BackgroundElementPoster
                        poster={poster}
                        cssClassesPoster={cssClassesPoster}
                        posterSettings={posterSettings}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />
                </div>
            )
        );
        case 'KenBurns': return (
            <div className={cssClassesBackground}>
                <KenBurnsImage
                    isInHighlight={isInHighlight}
                    oddSlide={oddSlide}
                    kenBurnsToggle={kenBurnsToggle}
                    isJustOneItem={isJustOneItem}
                    isMobile={isMobile}
                    autoplaySpeed={autoplaySpeed}
                    backgroundImage={backgroundImage}
                />
            </div>
        );
        case 'KenBurnsPosterCenter': return (
            <div className={cssClassesBackground}>
                <KenBurnsImage
                    isInHighlight={isInHighlight}
                    isMobile={isMobile}
                    oddSlide={oddSlide}
                    kenBurnsToggle={kenBurnsToggle}
                    isJustOneItem={isJustOneItem}
                    autoplaySpeed={autoplaySpeed}
                    backgroundImage={backgroundImage}
                >
                    <BackgroundElementPoster
                        poster={poster}
                        cssClassesPoster={cssClassesPoster}
                        posterSettings={posterSettings}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />
                </KenBurnsImage>
            </div>
        );
        case 'KenBurnsPosterRight': return (
            <div className={cssClassesBackground}>
                <KenBurnsImage
                    isMobile={isMobile}
                    isInHighlight={isInHighlight}
                    oddSlide={oddSlide}
                    kenBurnsToggle={kenBurnsToggle}
                    isJustOneItem={isJustOneItem}
                    autoplaySpeed={autoplaySpeed}
                    backgroundImage={backgroundImage}
                >
                    <BackgroundElementPoster
                        poster={poster}
                        cssClassesPoster={cssClassesPoster}
                        posterSettings={posterSettings}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />
                </KenBurnsImage>
            </div>
        );
        default: return (
            canParallax ? (
                <div className={cssClassesBackground} style={ambientStyle}></div>
            ) : (
                <div className={cssClassesBackground}>
                    <BackgroundElementBackground
                        src={finalImageURl}
                        srcFallback={imageUrl}
                        imgStyles={styles}
                        fallbackInUse={fallbackInUse}
                        setFallback={setFallback}
                    />
                </div>
            )
        );
    }
}

export default BackgroundVisuals;